import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=194f8b1f"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NotificationBell: require('/usr/src/app/components/NotificationBell.vue').default,Menu: require('/usr/src/app/components/Menu.vue').default,Header: require('/usr/src/app/components/Header.vue').default})
